<template>
  <v-container>
    <v-data-table
      :headers="headers"
      :items="projects_list"
      item-value="id"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Projects</v-toolbar-title>
          <a href="/#/pages/research/new-projects" class="mx-4"
            ><v-btn small class="">Create new</v-btn></a
          >
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.gads_client_id="{ item }">
        <span>{{ item.gads_client_id ? item.gads_client_id : 'N/A' }}</span>
      </template>

      <template v-slot:item.name="{ item }">
        <a :href="`#/pages/projects/${item.id}/clusters`">{{ item.name }}</a>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
  export default {
    data() {
      return {
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'Client ID', value: 'client_id' },
          { text: 'GADS Client ID', value: 'gads_client_id' },
          { text: 'Status', value: 'status' },
        ],
        projects_list: undefined,
      }
    },
    mounted() {
      this.apiGetProjectData()
    },
    methods: {
      apiGetProjectData() {
        this.apiGetProjects()
          .then(response => {
            this.projects_list = response.results
          })
          .catch(error => {
            console.log(error)
            return null
          })
      },
    },
  }
</script>

<style scoped>
  .v-container {
    padding: 16px;
  }
</style>
